import { render, staticRenderFns } from "./BCCSerial.vue?vue&type=template&id=4893fdc2"
import script from "./BCCSerial.vue?vue&type=script&lang=ts"
export * from "./BCCSerial.vue?vue&type=script&lang=ts"
import style0 from "./BCCSerial.vue?vue&type=style&index=0&id=4893fdc2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports